// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__8L3mW","faq_section":"_styles_faq_section__VVBgI"};